module.exports = __webpack_public_path__ + "img/27.8a7020f6.jpg";